var DOCS_URL = 'http://www.telerik.com/kendo-angular-ui/components/internationalization/troubleshooting/';
/**
 * @hidden
 */
export var errorSolutions = {
    'NoCurrencyDisplay': "Solution: " + DOCS_URL + "#toc-insufficient-default-locale",
    'NoLocale': "Solution: " + DOCS_URL + "#toc-missing-cldr-info"
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-intl/dist/es/error-solutions.js
// module id = ../../../../@progress/kendo-angular-intl/dist/es/error-solutions.js
// module chunks = 3